import React, {Component} from "react";
import Navbar from "../navbar/navbar.js";
import {Row, Col} from "antd";
import "./dashboard.css";

class Dashboard extends Component {
    render() {
        return (
            <div>
                <Navbar isUserAuthenticated={false}/>
                <Row>
                    <Col style={{backgroundColor: "red"}} span={21} push={3}>
                        <h3 style={{color: "black"}}>Welcome User</h3>
                    </Col>
                    <Col span={3} pull={21}>
                        <ul>
                            <li>Stats</li>
                            <li>Landers</li>
                            <li>Generator</li>
                            <li>Chat</li>
                        </ul>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboard.js